import React from 'react';
import { Link } from 'react-router-dom';
import {
    BookOpen,
    Target,
    Briefcase,
    Award,
    GraduationCap,
    Hospital,
    FlaskConical,
    ChevronRight
} from 'lucide-react';
import Footer from '../../../components/Footer';
import heroimg from '../../../assets/schools/pharma/B pharm.png';
import HowToApplySection from '../../../components/HowToApplySection';

// Placeholder for importing images - replace with actual image paths
const heroImage = heroimg;
const labImage1 = "/api/placeholder/400/300";
const labImage2 = "/api/placeholder/400/300";
const hospitalImage = "/api/placeholder/400/300";

const BachelorPharmacy = () => {
    const programSections = [
        {
            title: "Program Outcomes",
            items: [
                "Students will possess the knowledge and understanding of the Basic and Core Aspects of the Pharmacy Profession, including Biomedical sciences, Industrial and Manufacturing practices. ",
                "They will develop Leadership skills and Planning abilities that will aid in their Professional Practices. ",
                "They will acquire Advanced knowledge in all subject areas, including Analytical Chemistry, Medicinal chemistry, Industrial Pharmacy, Drug Design, Research Methodologies, and Regulatory Sciences through Training, Experimentation, and Outcome-Based Learning Approaches.",
            ],
            icon: <Target className="text-emerald-700" size={40} />
        },
        {
            title: "Career Prospects",
            items: [
                "Higher Education & Specialization such as M.Pharm (Master of Pharmacy), MBA in Healthcare/Pharma Management, Pharm.D (Post Baccalaureate)  ",
                "Pharmacist (Community or Hospital) ",
                "Pharmaceutical Industry  ",
                "Clinical Research & Pharmacovigilance  ",
                "Marketing & Sales (Medical Representative)  ",
                "Drug Inspector / Government Analyst  ",
                "Entrepreneurship ",
                "Jobs Abroad  ",
            ],
            icon: <Briefcase className="text-emerald-700" size={40} />
        }
    ];

    const uniqueSellingPoints = [
        "Renowned Domain Specific & Highly Rich Experienced Faculty ",
        "Centre of Excellence in Specific Domain & Technology for Experiential Learning ",
        "360° Advance Course Curriculum designed by Core Academia & Renowned Industry Experts ",
        "Live Industry Projects based Learning through-out the course ",
        "LMS based Pedagogy and Innovative Class Room Teaching Methodology ",
        "One – to – One Progress Monitoring & Mentoring Methodology throughout the course ",
        "Choice Based Credit System (CBCS) Based Assessments and Evaluation ",
        "Advance Diagnostic & Mentoring for Career and Placement throughout the Course",
        "Dynamic Programming & Core Skill Guidance throughout the course ",
        "Start-up & Idea Innovation Lab for Career & Professional Growth. ",

    ];

    return (
        <div className="bg-emerald-50">
            <div className="bg-white text-emerald-900 font-sans mx-4 md:mx-8 lg:mx-16 my-4 mt-[70px]">
                {/* Hero Section */}
                <div className="relative bg-gradient-to-r from-emerald-50 to-white">
                    <div className="container mx-auto px-4 py-16 md:py-24 flex flex-col-reverse md:flex-row items-center">
                        <div className="md:w-1/2 space-y-6">
                            <h1 className="text-4xl md:text-5xl font-bold text-emerald-800 leading-tight">
                                Bachelor of Pharmacy (B. Pharm –Regular)


                                <span className="block text-lg mt-2 font-medium text-emerald-600">
                                    Maya Devi University, Dehradun
                                </span>
                            </h1>
                            <p className="text-emerald-700 text-lg leading-relaxed">

                                The Bachelor of Pharmacy (B.Pharm) is a 4-year undergraduate professional degree in pharmaceutical sciences. It equips students with knowledge about drug composition, formulation, medicinal chemistry, pharmacology, and pharmacy practice. Graduates can work in pharmaceutical industries, research, or become registered pharmacists.



                            </p>
                            <div className="flex space-x-4">
                                <Link
                                    to="https://admission.maya.edu.in/"
                                    className="bg-emerald-600 hover:bg-emerald-700 text-white px-6 py-3 rounded-full 
                           transition duration-300 flex items-center group"
                                >
                                    Apply Now
                                    <ChevronRight
                                        className="ml-2 group-hover:translate-x-1 transition"
                                        size={20}
                                    />
                                </Link>
                            </div>
                        </div>
                        <div className="md:w-1/2 mb-8 md:mb-0 \ m-10">
                            <img
                                src={heroImage}
                                alt="Pharmacy Program"
                                className="rounded-xl shadow-lg hover:scale-105 transition duration-300"
                            />
                        </div>
                    </div>
                </div>

                {/* Eligibility and Program Details */}
                <div className="container mx-auto px-4 py-16 bg-emerald-50">
                    <div className="grid md:grid-cols-2 gap-8">
                        <div className="bg-white p-6 rounded-xl shadow-md">
                            <h2 className="text-2xl font-bold text-emerald-800 mb-4">
                                <GraduationCap className="inline mr-3 text-emerald-600" size={30} />
                                Eligibility Criteria
                            </h2>
                            <ul className="space-y-3 text-emerald-700">
                                <li>• Minimum age: 17 years as of 31st December</li>
                                <li>• 10+2 with Physics and Chemistry</li>
                                <li>• Mathematics or Biology from recognized board</li>
                                <li>• General Category: Minimum 50% marks</li>
                                <li>• SC/ST Category: Minimum 45% marks</li>
                            </ul>
                        </div>
                        <div className="bg-white p-6 rounded-xl shadow-md">
                            <h2 className="text-2xl font-bold text-emerald-800 mb-4">
                                <Hospital className="inline mr-3 text-emerald-600" size={30} />
                                Program Details
                            </h2>
                            <table className="w-full text-emerald-700">
                                <tbody>
                                    <tr>
                                        <td className="font-semibold">Duration:</td>
                                        <td>4 Years</td>
                                    </tr>
                                    {/* <tr>
                                        <td className="font-semibold">Approved By:</td>
                                        <td>Pharmacy Council of India</td>
                                    </tr>
                                    <tr>
                                        <td className="font-semibold">Total Seats:</td>
                                        <td>60</td>
                                    </tr>
                                    <tr>
                                        <td className="font-semibold">Certification:</td>
                                        <td>State Pharmacy Council Registration</td>
                                    </tr> */}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                {/* Program Sections */}
                <div className="container mx-auto px-4 py-16">
                    <div className="grid md:grid-cols-2 gap-8">
                        {programSections.map((section, index) => (
                            <div
                                key={index}
                                className="bg-emerald-50 p-6 rounded-xl shadow-md hover:shadow-lg transition"
                            >
                                <div className="flex items-center mb-4">
                                    {section.icon}
                                    <h3 className="text-2xl font-bold ml-4 text-emerald-800">
                                        {section.title}
                                    </h3>
                                </div>
                                <ul className="space-y-2 text-emerald-700">
                                    {section.items.map((item, idx) => (
                                        <li key={idx} className="flex items-start">
                                            <span className="mr-2 text-emerald-600">•</span>
                                            {item}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Images and Labs Section */}
                {/* <div className="container mx-auto px-4 py-16 bg-emerald-50">
        <h2 className="text-3xl font-bold text-center text-emerald-800 mb-12">
          <FlaskConical className="inline mr-3 text-emerald-600" size={40} />
          Our Facilities
        </h2>
        <div className="grid md:grid-cols-3 gap-8">
          {[
            { img: labImage1, title: "Advanced Laboratories" },
            { img: hospitalImage, title: "Hospital Collaboration" },
            { img: labImage2, title: "Research Facilities" }
          ].map((facility, index) => (
            <div 
              key={index} 
              className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-lg transition"
            >
              <img 
                src={facility.img} 
                alt={facility.title} 
                className="w-full h-64 object-cover hover:scale-105 transition"
              />
              <div className="p-4 text-center">
                <h3 className="text-xl font-semibold text-emerald-800">
                  {facility.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div> */}

                {/* USPs Section */}
                <div className="container mx-auto px-4 py-16">
                    <h2 className="text-3xl font-bold text-center text-emerald-800 mb-12">
                        Why Choose Us
                    </h2>
                    <div className="max-w-3xl mx-auto">
                        <div className="bg-emerald-50 p-8 rounded-xl shadow-lg hover:shadow-xl transition">
                            <div className="text-emerald-600 text-4xl mb-6 flex justify-center">
                                <Award size={60} />
                            </div>
                            <h3 className="text-2xl font-bold text-emerald-800 text-center mb-6">
                                Our USPs
                            </h3>
                            <ul className="space-y-3">
                                {uniqueSellingPoints.map((usp, index) => (
                                    <li
                                        key={index}
                                        className="flex items-center text-emerald-700 text-lg"
                                    >
                                        <div className="mr-3 text-emerald-600">•</div>
                                        {usp}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
                {/* Footer Section */}

            </div>
            <HowToApplySection />
            {/* Footer */}
            <div className="bg-emerald-50">
                <Footer />
            </div>
        </div>

    );
};

export default BachelorPharmacy